import { createSlice } from "@reduxjs/toolkit";
import { addRevision } from "../addRevision";
import { Container, Drink } from "../db";
import { syncPatchImagesReducer, syncSetDataReducer } from "../sync";

export const syncProperties = ["Drinks", "Containers"];

const ownItemsSlice = createSlice({
  name: "ownItems",
  initialState: {
    Drinks: [],
    revision: 0,
  } as OwnItems,
  reducers: {
    addDrink: (state, action) => {
      state.Drinks.push(action.payload);
      addRevision(state);
    },
    removeDrink: (state, action) => {
      state.Drinks = state.Drinks.filter(
        (drink) => drink.id !== action.payload
      );
      addRevision(state);
    },
    editDrink: (state, action) => {
      const { id, newState } = action.payload;
      const index = state.Drinks.findIndex((drink) => drink.id === id);
      if (index === -1) return;
      state.Drinks[index] = newState;
      addRevision(state);
    },
    syncPatchImages: syncPatchImagesReducer,
    syncSetData: syncSetDataReducer(syncProperties, "own-items"),
  },
});

export type OwnItems = {
  Drinks: Drink[];
  Containers: Container[];
  revision: number;
};

export const {
  addDrink,
  syncPatchImages,
  syncSetData,
  removeDrink,
  editDrink,
} = ownItemsSlice.actions;

export const initialState = ownItemsSlice.getInitialState();

export default ownItemsSlice.reducer;
